import { z } from 'zod';
import { JsonValueZod } from './json.value.zod';

export const ActionSchemaZod = z.object({
  id: z.string().min(1),
  key: z.string().min(1),
  label: z.string().optional(),
  config: z.record(z.string(), JsonValueZod).optional(),
}).strict();

export type ActionSchema = z.infer<typeof ActionSchemaZod>;
